import useSWR from "swr";
import apiRequest from "utils/apiRequestWithErrorCode";
import { StorageNotificationTemplate } from "@dashboard-v3/api";

export default function useStorageNotificationTemplates() {
  const { data, error, isLoading } = useSWR(
    "/storage-notification-templates",
    () =>
      apiRequest<StorageNotificationTemplate[]>(
        "GET",
        "/storage-notification-templates"
      ),
    { revalidateOnFocus: false }
  );

  const templates = data || [];

  const getTemplateNameById = (id: unknown) => {
    if (typeof id !== "string") return id;
    const found = templates.find(template => template.id === id);
    return found?.name || id;
  };

  return {
    templates,
    loading: isLoading,
    error,
    getTemplateNameById,
  };
}
